import { render, staticRenderFns } from "./ProjectsDropdown.vue?vue&type=template&id=70ecaf16&scoped=true"
import script from "./ProjectsDropdown.vue?vue&type=script&lang=js"
export * from "./ProjectsDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProjectsDropdown.vue?vue&type=style&index=0&id=70ecaf16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ecaf16",
  null
  
)

export default component.exports